export var ProtocolType;
(function (ProtocolType) {
    ProtocolType["HTTP_HLS"] = "http_hls";
    ProtocolType["HTTP_STREAM"] = "http_stream";
})(ProtocolType || (ProtocolType = {}));
export var FormatType;
(function (FormatType) {
    FormatType["FLV"] = "flv";
    FormatType["TS"] = "ts";
    FormatType["FMP4"] = "fmp4";
})(FormatType || (FormatType = {}));
export var CodecType;
(function (CodecType) {
    CodecType["AVC"] = "avc";
    CodecType["HEVC"] = "hevc";
})(CodecType || (CodecType = {}));
/**
 * p2p类型， 非合法值，取 NONE
 */
export var P2PType;
(function (P2PType) {
    /**
     * 播放 hls，不开启自研p2p
     */
    P2PType[P2PType["HLS_NOT_P2P"] = -1] = "HLS_NOT_P2P";
    /**
     * 不开启p2p，默认播放 flv
     */
    P2PType[P2PType["NONE"] = 0] = "NONE";
    /**
     * 自研p2p，播放 hls
     */
    P2PType[P2PType["HLS_BILI"] = 1] = "HLS_BILI";
    /**
     * 腾讯p2p, 播放 flv
     */
    P2PType[P2PType["FLV_QVB"] = 8] = "FLV_QVB";
})(P2PType || (P2PType = {}));
/**
 * 后端接口定义的 ErrorCode
 */
export var ApiErrorCode;
(function (ApiErrorCode) {
    /**
     * 地区限制
     */
    ApiErrorCode[ApiErrorCode["AreaBlock"] = 6005] = "AreaBlock";
})(ApiErrorCode || (ApiErrorCode = {}));
/**
 * 外部监听的事件
 * <a href="./player-room.html#roomplayer监听事件示例">示例</a>
 */
export var ExternalEventType;
(function (ExternalEventType) {
    ExternalEventType["Initialized"] = "initialized";
    ExternalEventType["PlayerStateChange"] = "playerStateChange";
    ExternalEventType["LiveStateChange"] = "liveStateChange";
    ExternalEventType["StartPlayRound"] = "startPlayRound";
    ExternalEventType["VideoStateChange"] = "videoStateChange";
    ExternalEventType["FullscreenChange"] = "fullscreenChange";
    ExternalEventType["Playing"] = "playing";
    ExternalEventType["Paused"] = "paused";
    ExternalEventType["SwitchLine"] = "switchLine";
    ExternalEventType["SwitchQuality"] = "switchQuality";
    ExternalEventType["WebFullscreen"] = "webFullscreen";
    ExternalEventType["FeedBackClick"] = "feedBackClick";
    ExternalEventType["BlockSettingClick"] = "blockSettingClick";
    ExternalEventType["Set"] = "set";
    ExternalEventType["Reload"] = "reload";
    ExternalEventType["GuidChange"] = "guidChange";
    ExternalEventType["InitDanmaku"] = "initDanmaku";
    ExternalEventType["AddDanmaku"] = "addDanmaku";
    ExternalEventType["SendDanmaku"] = "sendDanmaku";
    ExternalEventType["ReceiveOnlineCount"] = "receiveOnlineCount";
    ExternalEventType["ReceiveMessage"] = "receiveMessage";
    ExternalEventType["UserLogin"] = "userLogin";
    ExternalEventType["SendGift"] = "sendGift";
    ExternalEventType["FirstLoadedAPIPlayer"] = "firstLoadedAPIPlayer";
    ExternalEventType["FirstLoadedAPIPlayurl"] = "firstLoadedAPIPlayurl";
    ExternalEventType["FirstLoadStart"] = "firstLoadStart";
    ExternalEventType["FirstLoadedMetaData"] = "firstLoadedMetaData";
    ExternalEventType["FirstPlaying"] = "firstPlaying";
    ExternalEventType["EnterTheRoom"] = "enterTheRoom";
    ExternalEventType["OperableElementsChange"] = "operableElementsChange";
    ExternalEventType["AutoPlay"] = "autoPlay";
    ExternalEventType["SwitchQualityNotLogin"] = "switchQualityNotLogin";
    ExternalEventType["Recommend"] = "recommend";
    ExternalEventType["DanmakuMaskChange"] = "danmakuMaskChange";
    ExternalEventType["DanmakuMaskStatusChange"] = "danmakuMaskStatusChange";
    ExternalEventType["CtrlVisibleChange"] = "ctrlVisibleChange";
    ExternalEventType["WebPlayerCreated"] = "webPlayerCreated";
    ExternalEventType["FirstFrame"] = "FirstFrame";
    ExternalEventType["SEIData"] = "SEIData";
    ExternalEventType["VolumeChange"] = "VolumeChange";
    ExternalEventType["VideoDirectionChange"] = "VideoDirectionChange";
    ExternalEventType["UserClickPlayIcon"] = "UserClickPlayIcon";
    ExternalEventType["MergeStream"] = "MergeStream";
    ExternalEventType["SEIParseData"] = "SEIParseData";
    ExternalEventType["OrientationChange"] = "OrientationChange";
    ExternalEventType["UserRedirect"] = "UserRedirect";
    /**
     * 不能带声音自动播放
     */
    ExternalEventType["MutePlay"] = "MutePlay";
    /**
     * 不完自动播放
     */
    ExternalEventType["NotAutoPlay"] = "NotAutoPlay";
})(ExternalEventType || (ExternalEventType = {}));
export var CorePlayerType;
(function (CorePlayerType) {
    CorePlayerType["fMp4Player"] = "fMp4Player";
    CorePlayerType["Hls7Player"] = "Hls7Player";
    CorePlayerType["NativePlayer"] = "NativePlayer";
})(CorePlayerType || (CorePlayerType = {}));
export var SEIType;
(function (SEIType) {
    SEIType["LIVE_SEI_CHANNEL"] = "LIVE_SEI_CHANNEL";
    SEIType["BILIMASK__SVGBIN"] = "BILIMASK__SVGBIN";
})(SEIType || (SEIType = {}));
//# sourceMappingURL=interface.js.map